import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import "./style.css";

const YoutubeVideoModel = ({ show, close, videoUrl, title }) => {
  const isMobile = window.innerWidth < 768;

  const VideoUrl = videoUrl;
  const getEmbedUrl = (url, autoplay = true) => {
    if (!url) return null;

    try {
      const urlObj = new URL(url);
      if (
        !urlObj.hostname.includes("youtube.com") &&
        !urlObj.hostname.includes("youtu.be")
      ) {
        return null;
      }

      const videoId = urlObj.searchParams.get("v");
      const listId = urlObj.searchParams.get("list");

      if (listId) {
        return `https://www.youtube.com/embed/videoseries?list=${listId}${
          autoplay ? "&autoplay=1&mute=1" : ""
        }`;
      }

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}${
          autoplay ? "?autoplay=1&mute=1" : ""
        }`;
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  const embedUrl = getEmbedUrl(VideoUrl, !isMobile);

  return (
    <>
      <Modal
        show={show}
        centered
        onHide={close}
        onClick={(e) => e.stopPropagation()}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "black" }}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-3">
          {embedUrl && (
            <div className="">
              <div className="video-container ratio ratio-16x9">
                <iframe
                  src={embedUrl}
                  title="Planner"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  style={{ borderRadius: "12px" }}
                />
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default YoutubeVideoModel;
